import { render, staticRenderFns } from "./Boothevent.vue?vue&type=template&id=1ac31f4e&"
import script from "./Boothevent.vue?vue&type=script&lang=js&"
export * from "./Boothevent.vue?vue&type=script&lang=js&"
import style0 from "./Boothevent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports